import { useEffect, useState } from 'react';
import { api } from '../api/client';
import type { Pricing } from '../api/types';
import plan from '../../../src/config/hosty-plan.json';

export const DEFAULT_PRICING: Pricing = { ...plan, interval: 'month' };

export function usePricing() {
  const [pricing, setPricing] = useState<Pricing>(DEFAULT_PRICING);
  useEffect(() => {
    let mounted = true;
    api.get<Pricing>('/api/license/pricing').then((value) => {
      if (mounted && value.id === plan.id && value.amountCents === plan.amountCents) setPricing(value);
    }).catch(() => { /* Display the versioned plan; checkout validates Stripe separately. */ });
    return () => { mounted = false; };
  }, []);
  return pricing;
}
